interface ChipOption<T extends string> {
  value: T;
  label: string;
}

interface OptionChipsProps<T extends string> {
  label: string;
  options: ChipOption<T>[];
  selected: T;
  onChange: (value: T) => void;
  disabled?: boolean;
  suffix?: string;
}

export function OptionChips<T extends string>({
  label,
  options,
  selected,
  onChange,
  disabled,
  suffix,
}: OptionChipsProps<T>) {
  return (
    <div className="landing-options-section">
      <div className="landing-options-label">
        <span>{label}</span>
        {suffix && <span className="landing-options-suffix">{suffix}</span>}
      </div>
      <div className="landing-chip-group">
        {options.map((opt) => (
          <button
            key={opt.value}
            type="button"
            className="landing-chip"
            data-active={selected === opt.value || undefined}
            disabled={disabled}
            onClick={() => {
              onChange(opt.value);
            }}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}
